import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Mail, Phone, MapPin, Linkedin, Instagram, 
  Twitter, Facebook, ExternalLink, ArrowRight, ChevronUp 
} from 'lucide-react';
// import bgimg from "../global-images/footerimgbg.webp";
import bgimg from "../global-images/sliderimg19.png";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const bgImage = bgimg;

  return (
    <footer className="relative bg-slate-900 text-slate-300 border-t border-slate-800 font-sans overflow-hidden">
      
      {/* --- CUSTOM CSS FOR ANIMATIONS --- */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>

      {/* --- BACKGROUND --- */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img 
          src={bgImage} 
          alt="Footer Background" 
          className="w-full h-full object-cover opacity-15" 
        />
      </div>

      {/* --- MAIN CONTENT --- */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 animate-fade-in-up">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          
          {/* Column 1: Brand & Map (Span 4) */}
          <div className="lg:col-span-4 space-y-8">
            <div>
              <h3 className="text-2xl font-extrabold tracking-tight text-white mb-2">
                IIT Ropar-TBIF <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300"></span>
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed max-w-xs border-l-2 border-blue-500/30 pl-4">
                Fostering innovation as a DST, Govt. of India recognized Section-8 Organization.
              </p>
            </div>

            {/* Address */}
            <div className="flex items-start gap-4 group cursor-default">
                <div className="p-2 rounded-lg bg-slate-800 text-blue-400 group-hover:bg-blue-500 group-hover:text-white transition-all duration-300 shadow-md group-hover:shadow-blue-500/20">
                  <MapPin className="w-5 h-5 shrink-0" />
                </div>
                <p className="text-sm text-slate-400 leading-relaxed group-hover:text-slate-200 transition-colors duration-300">
                  Top Floor (East Wing), M. Visvesvaraya Block,<br/>
                  Indian Institute Of Technology, Ropar,<br/>
                  Rupnagar - 140001, Punjab, India
                </p>
            </div>
            
            {/* Map with Lift Effect */}
            <div className="rounded-2xl overflow-hidden border border-slate-700/50 h-40 w-full bg-slate-800/50 backdrop-blur-sm shadow-lg transition-all duration-500 hover:shadow-2xl hover:shadow-blue-900/20 hover:-translate-y-1">
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3421.0733435684897!2d76.47062892589317!3d30.96843537447144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3905542fe45e58f7%3A0x5d16c2617cfdbdb8!2sIndian%20Institute%20Of%20Technology%E2%80%93Ropar%20(IIT%E2%80%93Ropar)!5e0!3m2!1sen!2sin!4v1769436357247!5m2!1sen!2sin=&output=embed"
                    width="100%" 
                    height="100%" 
                    style={{ border: 0 }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="IIT Ropar Map"
                    className="opacity-60 hover:opacity-100 transition-opacity duration-500"
                ></iframe>
            </div>
          </div>

          {/* Column 2: Links (Span 3) */}
          <div className="lg:col-span-3 lg:pl-8">
            <h4 className="text-white font-bold text-lg mb-8 relative inline-block">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full"></span>
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Leadership Team', path: '/team' },
                { name: 'Incubator Facilities', path: '/facilities' },
                { name: 'Portfolio Startups', path: '/portfolio' },
                { name: 'Events', path: '/events' },
                { name: 'Careers', path: '/career' },
                { name: 'Contact Us', path: '/contact-us' }
              ].map((link, idx) => (
                <li key={idx}>
                  <Link 
                    to={link.path} 
                    onClick={() => window.scrollTo(0, 0)}
                    className="group flex items-center gap-3 text-sm text-slate-400 hover:text-blue-300 transition-all duration-300"
                  >
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-slate-800/50 text-blue-500 group-hover:bg-blue-500 group-hover:text-white transition-all duration-300 group-hover:scale-110">
                        <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover:translate-x-0.5" />
                    </span>
                    <span className="group-hover:translate-x-1 transition-transform duration-300">{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact & CTA (Span 5) */}
          <div className="lg:col-span-5 lg:pl-4">
            <h4 className="text-white font-bold text-lg mb-8 relative inline-block">
              Connect with Us
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full"></span>
            </h4>
            
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
               <ContactBox 
                 icon={<Mail className="w-5 h-5" />} 
                 label="Email Us" 
                 value="tbioffice@iitrpr.ac.in" 
                 href="mailto:tbioffice@iitrpr.ac.in" 
               />
               <ContactBox 
                 icon={<Phone className="w-5 h-5" />} 
                 label="Call Us" 
                 value="+91-9417484881" 
                 href="tel:+919417484881" 
               />
            </div>

            <div className="mb-8">
               <div className="flex items-center gap-4 mb-4">
                   <h5 className="text-slate-400 text-xs font-bold uppercase tracking-widest">Follow Socials</h5>
                   <div className="h-px bg-slate-800 flex-1"></div>
               </div>
               <div className="flex gap-4">
                  <SocialLink href="https://www.linkedin.com/company/iit-ropar-technology-business-incubator-foundation" icon={<Linkedin size={20} />} color="hover:bg-[#0077b5]" />
                  <SocialLink href="https://x.com/iitrprtbif" icon={<Twitter size={20} />} color="hover:bg-black" />
                  <SocialLink href="https://www.instagram.com/iitropartbif/" icon={<Instagram size={20} />} color="hover:bg-pink-600" />
                  <SocialLink href="https://www.facebook.com/p/IIT-Ropar-TBIF-100064188995310/" icon={<Facebook size={20} />} color="hover:bg-[#1877F2]" />
               </div>
            </div>

            {/* CTA Button with Glow Animation */}
            <a 
                href="https://forms.gle/Fz2pn47EqTscZK4T8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group relative w-full flex items-center justify-center gap-3 bg-blue-600 text-white font-bold py-4 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(37,99,235,0.4)] hover:-translate-y-1"
            >
                {/* Button background gradient animation */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-600 bg-[length:200%_auto] transition-all duration-500 group-hover:bg-right"></div>
                
                <span className="relative z-10 flex items-center gap-2">
                    Incubate with Us 
                    <ExternalLink size={18} className="transition-transform duration-300 group-hover:rotate-45" />
                </span>
            </a>
          </div>

        </div>
      </div>

      {/* --- COPYRIGHT BAR --- */}
      <div className="relative z-10 border-t border-slate-800 bg-slate-950/50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
            <p>© {currentYear} TBIF IIT Ropar. All rights reserved.</p>
            <div className="flex items-center gap-6">
                <a href="/" className="hover:text-blue-400 transition-colors duration-200">Privacy Policy</a>
                <a href="/" className="hover:text-blue-400 transition-colors duration-200">Terms of Service</a>
                
                {/* Back to Top Button */}
                <button 
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                  className="group flex items-center justify-center w-8 h-8 rounded bg-slate-800 hover:bg-blue-600 text-slate-400 hover:text-white transition-all duration-300"
                  aria-label="Back to Top"
                >
                    <ChevronUp size={16} className="group-hover:-translate-y-0.5 transition-transform" />
                </button>
            </div>
        </div>
      </div>
    </footer>
  );
};

/* --- HELPER COMPONENTS FOR CLEANER CODE --- */

const ContactBox = ({ icon, label, value, href }) => (
    <a href={href} className="flex items-center gap-3 p-3 rounded-xl bg-slate-800/40 border border-slate-700/50 hover:bg-slate-800 hover:border-blue-500/30 transition-all duration-300 group">
        <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-500 group-hover:bg-blue-500 group-hover:text-white transition-colors duration-300">
            {icon}
        </div>
        <div className="overflow-hidden">
            <span className="block text-[10px] text-slate-500 font-bold uppercase tracking-wider mb-0.5">{label}</span>
            <span className="block text-sm font-medium text-slate-300 truncate group-hover:text-white transition-colors">{value}</span>
        </div>
    </a>
);

const SocialLink = ({ href, icon, color }) => (
    <a 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        className={`w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 border border-slate-700 transition-all duration-300 hover:text-white hover:border-transparent hover:-translate-y-1 hover:shadow-lg ${color}`}
    >
        {icon}
    </a>
);

export default Footer;